<qpx-preview-pane-control-groups [choices]="choices()" />
<qpx-preview-pane-buttons [choices]="choices()" />
